import axios from 'axios'

export default {
    get: () => axios.get('serials'),
    getByType: (type) => axios.get('serials/type:'+type),
    getDefault: (type) => axios.get('serials/default:'+type),
    store: (data) => axios.post('serials/store', data),
    update: (data) => axios.put('serials/'+data.id, data),
    delete: (id) => axios.delete('serials/'+id, )
}